<template>
    <DropFile :accept="imageExt" @file="fileAdded" />
</template>

<script>
// что это вообще...

const IMAGE_EXT = [
    '.jpg', '.jpeg', '.png',
    '.gif', '.svg', '.webp',
    '.avif', '.apng', '.bmp',
    '.ico',
];

export default {
    title: 'image',
    icon: 'Image',
    description: 'Insert Image',

    props: {
        options: {
            type: Object,
        },
    },
    computed: {
        uploadURL() {
            return this.options.image.uploadURL;
        },
        imageExt() {
            return IMAGE_EXT;
        },
    },
    methods: {
        fileAdded({ accepted: files }) {
            const file = files[0];

            if (file && this.uploadURL !== 'None')
                return;

            const reader = new FileReader();

            reader.addEventListener('load', () => {
                this.$emit('exec', 'insertHTML', `<img src=${ reader.result }>`);
            }, false);

            reader.readAsDataURL(file);
        },
    },
};
</script>
